import React, { useMemo, useState, useEffect } from "react"
import { Link } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"

// import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"

import { SimpleStringValue } from "helpers/common_helper_functions"
import { SaveToast } from "components/Common/SaveToast"
import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"

import {
  getAllSchoolStaff,
  updateSchoolStaff,
  deleteSchoolStaff,
} from "helpers/backendHelpers/schoolStaff"
const SchoolStaff = props => {
  document.title = "School Staff | LMS Ghana"

  const [deleteModal, setDeleteModal] = useState(false)
  const [staffs, setStaffs] = useState([])
  const [schoolStaff, setStaff] = useState({})
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchAllSchoolStaff()
  }, [saved])

  const fetchAllSchoolStaff = async () => {
    try {
      setLoading(true)
      const response = await getAllSchoolStaff()
      let { schoolStaffs } = response.data || {}
      schoolStaffs = schoolStaffs || []
      setStaffs(schoolStaffs)
      setLoading(false)
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching SchoolStaff"

      setStaffs([])
      setLoading(false)

      return SaveToast({ message, type: "error" })
    }
  }

  const onClickDelete = staff => {
    setStaff(staff)
    setDeleteModal(true)
  }

  const handleUpdateSchoolStaffStatus = async (id, status) => {
    if (!id) {
      return SaveToast({
        message: "Please Enter Staff Id",
        type: "error",
      })
    }
    try {
      const response = await updateSchoolStaff(id, {
        ss_status: status,
      })
      const message =
        response?.message || "SchoolStaff Status Updated Successfully"
      SaveToast({ message, type: "success" })

      setSaved(prevSaved => !prevSaved)
      return
    } catch (error) {
      const message =
        error?.message || "There Was A Problem Updating SchoolStaff Status"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleDeleteSchoolStaff = async () => {
    if (!schoolStaff.ss_id) {
      return SaveToast({ message: "Invalid School ID", type: "error" })
    }
    try {
      const response = await deleteSchoolStaff(schoolStaff.ss_id)
      const message = response?.message || "SchoolStaff Deleted Successfully"
      SaveToast({ message, type: "success" })
      setSaved(prevSaved => !prevSaved)
      setDeleteModal(false)
      return
    } catch (error) {
      const message =
        error?.message || "There was a problem deleting SchoolStaff"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleAddButtonClick = () => {
    props.history.push("/school-staff/add")
  }

  const columns = useMemo(
    () => [
      {
        Header: "Role",
        accessor: "ss_staffRole",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "ss_email",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Full Name",
        accessor: "ss_fullName",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Phone Number",
        accessor: "ss_phoneNumber",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "ss_status",
        disableFilters: true,
        Cell: cellProps => {
          const cellData = cellProps.row.original
          return (
            <div className="form-check form-switch form-switch-md">
              <input
                type="checkbox"
                className="form-check-input bg-dark"
                id={`ss_status_checkbox-${cellData.ss_id}`}
                name={`ss_status_checkbox-${cellData.ss_id}`}
                defaultChecked={cellData.ss_status}
                onChange={e => {
                  let { checked, name } = e.target
                  document.getElementById(name).checked = checked
                  return handleUpdateSchoolStaffStatus(cellData.ss_id, checked)
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-dark"
                onClick={() => {
                  props.history.push(
                    "/school-staff/view/" + cellProps.row.original.ss_id
                  )
                }}
              >
                <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  props.history.push(
                    "/school-staff/edit/" + cellProps.row.original.ss_id
                  )
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const staffData = cellProps.row.original
                  onClickDelete(staffData)
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )
  const printColumns = useMemo(
    () => [
      {
        Header: "Role",
        accessor: "ss_staffRole",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "ss_email",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Full Name",
        accessor: "ss_fullName",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Phone Number",
        accessor: "ss_phoneNumber",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "ss_status",
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.row?.original?.ss_status ? "Active" : "Inactive"
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSchoolStaff}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          {/* <Breadcrumbs title="School" breadcrumbItem="Staff" /> */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={staffs}
                    isGlobalFilter={true}
                    isAddOptions={true}
                    addButtonLabel="Add Staff Member"
                    handleAddButtonClick={handleAddButtonClick}
                    customPageSize={10}
                    className="custom-header-css"
                    dataFetchLoading={loading}
                    canExportCsv={true}
                    csvFileName={`schoolstaffs.csv`}
                    csvLink="/api/v1/admin/school-staff/download/data"
                    canPrint={true}
                    printColumns={printColumns}
                    noDataMessage="No system activity found."
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SchoolStaff
